// 3rd
import { Model } from '@vuex-orm/core';
// utils
import {
    api,
    authHeaders,
    errorHandler,
} from '../utils/api';
import {
    API_ENDPOINT_FETCH_TRANSACTIONS,
    API_ENDPOINT_FETCH_TRANSACTIONS_LATEST,
    LOADER_FETCH_TRANSACTIONS,
    LOADER_FETCH_LATEST_TRANSACTIONS,
} from '../utils/constants';
import env from '../utils/env';

export default class Transaction extends Model {
    static entity = 'transactions';

    static fields() {
        return {
            id: this.attr(null),
            transaction_type_id: this.attr(''),
            canceled: this.attr(''),
            wallet_id: this.attr(''),
            company_id: this.attr(''),
            value: this.attr(''),
            created_at: this.attr(''),
            updated_at: this.attr(''),
            description: this.attr(''),
            type: this.attr(''),
            type_id: this.attr(''),
            meta: this.attr({}),
            reason: this.attr(''),
        }
    }

    // api calls
    static async fetch() {
        Transaction.store().dispatch('wait/start', LOADER_FETCH_TRANSACTIONS);

        const response = await api.get(API_ENDPOINT_FETCH_TRANSACTIONS, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data } = response;
        const { transactions } = data;

        Transaction.insert({
            data: transactions,
        });

        Transaction.store().dispatch('wait/end', LOADER_FETCH_TRANSACTIONS);
    }

    static async fetchLatest() {
        Transaction.store().dispatch('wait/start', LOADER_FETCH_LATEST_TRANSACTIONS);

        const response = await api.get(API_ENDPOINT_FETCH_TRANSACTIONS_LATEST, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data } = response;
        const { latest_transactions } = data;

        Transaction.insert({
            data: latest_transactions,
        });

        Transaction.store().dispatch('wait/end', LOADER_FETCH_LATEST_TRANSACTIONS);
    }

    // getters
    static getLatest() {
        return Transaction.query().orderBy('created_at', 'desc').limit(env('dashboard-transaction-limit')).get();
    }
}
